import styled from 'styled-components';

import { mediaConfined } from '@xing-com/layout-tokens';
import {
  scale020,
  scale130,
  scale140,
  scale200,
  space3XL,
} from '@xing-com/tokens';
import { BodyCopy, Headline } from '@xing-com/typography';

export const Container = styled.section`
  margin-bottom: ${space3XL};
`;

export const Title = styled(Headline)`
  margin-bottom: ${scale130};

  @media ${mediaConfined} {
    margin-bottom: calc(${scale020} + ${scale140});
  }
`;

export const Text = styled(BodyCopy)`
  margin-bottom: calc(${scale020} + ${scale200});

  @media ${mediaConfined} {
    margin-bottom: ${space3XL};
  }
`;
